import React from 'react'
import Slip from '../../assets/icons/slip.svg'
import DangerCircle from '../../assets/icons/dangerCircle.svg'
import Letter from '../../assets/icons/letter.svg'
import Printing from '../../assets/icons/printing.svg'
import DetailsCard from '../DetailsCard'
import title_icon1 from '../../assets/icons/examIcon1.svg'
import title_icon2 from '../../assets/icons/examIcon2.svg'
import title_icon3 from '../../assets/icons/examIcon3.svg'
import title_icon4 from '../../assets/icons/examIcon4.svg'
import printing1 from '../../assets/images/processes/printing1.png'
import printing2 from '../../assets/images/processes/printing2.png'
import printing3 from '../../assets/images/processes/printing3.png'
import printing4 from '../../assets/images/processes/printing4.png'
import printing5 from '../../assets/images/processes/printing5.png'
import printing6 from '../../assets/images/processes/printing6.png'
import condonement1 from '../../assets/images/processes/condonement1.png'
import condonement2 from '../../assets/images/processes/condonement2.png'
import condonement3 from '../../assets/images/processes/condonement3.png'
import condonement4 from '../../assets/images/processes/condonement4.png'
import condonement5 from '../../assets/images/processes/condonement5.png'
import condonement6 from '../../assets/images/processes/condonement6.png'
import condonement7 from '../../assets/images/processes/condonement7.png'
import change1 from '../../assets/images/processes/change1.png'
import change2 from '../../assets/images/processes/change2.png'
import change3 from '../../assets/images/processes/change3.png'
import change4 from '../../assets/images/processes/change4.png'
import change5 from '../../assets/images/processes/change5.png'
import change6 from '../../assets/images/processes/change6.png'
import change7 from '../../assets/images/processes/change7.png'
import letter1 from '../../assets/images/processes/letter1.png'
import letter2 from '../../assets/images/processes/letter2.png'
import letter3 from '../../assets/images/processes/letter3.png'
import letter4 from '../../assets/images/processes/letter4.png'
import letter5 from '../../assets/images/processes/letter5.png'
import letter6 from '../../assets/images/processes/letter6.png'



const PostExam = ({setData, setModal}) => {
    const syllabus = [
        {
          id: 1,
          name: 'Print result slip',
          icon: Slip,
          alt: 'Slip_icon',
          title: 'Post exam and admission',
          title_icon: title_icon1,
          images : [
            {
              id: 1,
              img: printing1,
            },
            {
              id: 2,
              img: printing2,
            },
            {
              id: 3,
              img: printing3,
            },
            {
              id: 4,
              img: printing4,
            },
            {
              id: 5,
              img: printing5,
            },
            {
              id: 6,
              img: printing6,
            },
          ],
          img_alt : 'entry_image'
        },
        {
          id: 2,
          name: 'Condonement of illegal admission',
          icon: DangerCircle,
          alt: 'circle_icon',
          title: 'Condonement of illegal admission',
          title_icon: title_icon2,
          images : [
            {
              id: 1,
              img: condonement1,
            },
            {
              id: 2,
              img: condonement2,
            },
            {
              id: 3,
              img: condonement3,
            },
            {
              id: 4,
              img: condonement4,
            },
            {
              id: 5,
              img: condonement5,
            },
            {
              id: 6,
              img: condonement6,
            },
            {
              id: 7,
              img: condonement7,
            },
          ],
          img_alt : 'entry_image'
        },
        {
          id: 3,
          name: 'Change of admission letter',
          icon: Letter,
          alt: 'letter_icon',
          title: 'Change of admission letter',
          title_icon: title_icon3,
          images : [
            {
              id: 1,
              img: change1,
            },
            {
              id: 2,
              img: change2,
            },
            {
              id: 3,
              img: change3,
            },
            {
              id: 4,
              img: change4,
            },
            {
              id: 5,
              img: change5,
            },
            {
              id: 6,
              img: change6,
            },
            {
              id: 7,
              img: change7,
            },
          ],
          img_alt : 'entry_image'
        },
        {
          id: 4,
          name: 'Admission letter printing',
          icon: Printing,
          alt: 'download_icon',
          title: 'Admission letter printing',
          title_icon: title_icon4,
          images : [
            {
              id: 1,
              img: letter1,
            },
            {
              id: 2,
              img: letter2,
            },
            {
              id: 3,
              img: letter3,
            },
            {
              id: 4,
              img: letter4,
            },
            {
              id: 5,
              img: letter5,
            },
            {
              id: 6,
              img: letter6,
            },
          ],
          img_alt : 'entry_image'
        }
      ]

      const handleModal = (item) => {
        setModal(item)
        setData(item)
      }

      
  return (
    <div className='flex items-center justify-between w-full flex-wrap mt-11 md:justify-start'>
            {syllabus.map((item) => {
              return(
                <DetailsCard onClick={()=>handleModal(item)} key={item.id} data={item} index={item.id} />
              )
            })}
    </div>
  )
}

export default PostExam
